var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{attrs:{"id":"amount"}},[(_vm.balanceRates)?[_vm._v(" "+_vm._s(_vm._f("convertBalance")(_vm.value,_vm._currency, _vm.balanceRates))+" ")]:[_vm._v(_vm._s(_vm.value))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }